/* eslint-disable @dhl/mui/no-hardcoded-colors */
import { SvgIcon, SvgIconProps } from '@mui/material'

export const IDealWero = ({ viewBox = '0 0 40 26', ...props }: SvgIconProps) => (
  <SvgIcon viewBox={viewBox} fill="none" {...props} xmlns="http://www.w3.org/2000/svg">
    <path fill="#fff48d" d="M0 0h40v26H0z" />
    <path
      fill="#fff"
      d="M2.9363 7.8055v10.4043c0 .4981.4096.9054.91.9054h6.2464c4.7224 0 6.769-2.6308 6.769-6.1213S14.8144 6.9 10.092 6.9H3.8455c-.5003 0-.91.4073-.91.9055z"
    />
    <path
      fill="#c06"
      d="M7.1172 9.4538v7.6881h3.3616c3.0526 0 4.3761-1.7162 4.3761-4.1427s-1.3242-4.1243-4.3761-4.1243H7.6992c-.3227 0-.582.2624-.582.5797z"
    />
    <path
      fill="#232323"
      fillRule="evenodd"
      d="M4.6595 18.2868h5.4318c3.817 0 5.923-1.8788 5.923-5.2884 0-1.9649-.7689-5.2655-5.923-5.2655H4.6595c-.482 0-.8734.389-.8734.8696v8.8155c0 .4798.3913.8695.8734.8695zm-.5828-9.6843a.5795.5795 0 0 1 .582-.5797h5.4318c2.1015 0 5.6317.6476 5.6317 4.9756 0 3.2235-2.0016 4.9985-5.6317 4.9985h-5.431a.579.579 0 0 1-.582-.5797V8.6025z"
      clipRule="evenodd"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M8.7704 11.8809a.95.95 0 0 0-.325-.0549v-.0046h-.7696v1.8566h.7788c.138 0 .2578-.0274.3608-.0732.1022-.0503.1869-.1144.254-.1968s.116-.1831.151-.2975a1.4 1.4 0 0 0 .0488-.3753c0-.1556-.022-.2883-.0625-.4027-.0442-.1099-.1022-.206-.1732-.2838-.0755-.0732-.1601-.1327-.2624-.1693zm-.1823 1.4318a.55.55 0 0 1-.1694.0274v.0046h-.3516v-1.1709h.2845c.0976 0 .1777.0137.2449.0412a.397.397 0 0 1 .1601.1236c.0397.0503.071.119.0893.1922.0175.0732.0267.1602.0267.2517 0 .1053-.0137.1877-.0397.2609a.54.54 0 0 1-.1022.1739.33.33 0 0 1-.1426.0961z"
      clipRule="evenodd"
    />
    <path
      fill="#fff"
      d="M10.8759 11.8269v.3433h-.9527v.3981h.8765v.3158h-.8765v.4531h.9749v.3433H9.5273v-1.8566h1.3486v.0045z"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="m12.9138 13.6833-.6766-1.8566h-.4135l-.6811 1.8566h.4004l.1427-.4119h.6766l.138.4119h.4142zm-.8818-1.3997.2273.6811h-.4668l.2357-.6811h.0045z"
      clipRule="evenodd"
    />
    <path fill="#fff" d="M13.5599 11.826v1.5142h.8811v.3432h-1.2769v-1.8566h.3958z" />
    <path
      fill="#232323"
      d="M5.5552 13.7109c.4821 0 .8727-.3906.8727-.8734s-.3906-.8734-.8727-.8734c-.482 0-.8726.3906-.8726.8734s.3906.8734.8726.8734M6.0739 17.2037c-.6759 0-1.2175-.5835-1.2175-1.3005v-1.0153c0-.3585.2708-.6529.611-.6529s.611.2898.611.6529v2.3158z"
    />
    <path
      fill="#1d1c1c"
      d="M33.0342 13.0496c0-1.0206.7261-1.9505 1.9802-1.9505s1.9855.9306 1.9855 1.9505S36.2737 15 35.0144 15c-1.2541 0-1.9802-.9306-1.9802-1.9504m2.8635 0c0-.492-.3242-.9459-.8833-.9459-.5592 0-.8833.4546-.8833.9459s.3295.9466.8833.9466.8833-.4546.8833-.9466M32.2635 13.7742c.418-.238.6689-.6926.6689-1.1945 0-.7452-.5385-1.3799-1.3745-1.3799h-1.7552v3.7003h1.087v-.9459h.2037l.6216.9459h1.28zm-.9245-.672h-.4493v-1.0465h.4546c.2929 0 .4806.238.4806.5232s-.1938.5233-.4859.5233M24.8397 11.1952l-.6522 2.2052-.6362-2.2052h-.8657l-.6415 2.2052-.6469-2.2052H20.25l1.3143 3.6934h.9435l.6103-2.0107.6049 2.0107h.9489l1.3142-3.6934h-1.1472zM27.6327 13.987h-.0022c-.4066 0-.6919-.2456-.8139-.5705h2.762a2.1 2.1 0 0 0 .0336-.3738c0-1.0176-.7239-1.9459-1.9795-1.9466v1.0023c.4089.0007.6911.2463.8124.5705h-2.7582a2.1 2.1 0 0 0-.0336.3738c0 1.0183.7247 1.9474 1.9764 1.9474h.0023V13.987z"
    />
    <path
      fill="url(#a-IDealWero)"
      d="M27.6288 14.9892c.0428 0 .0847-.0015.1259-.0031.254-.0129.4851-.0648.6911-.1479a1.81 1.81 0 0 0 .54-.3372 1.83 1.83 0 0 0 .3791-.4805 2 2 0 0 0 .1961-.5233h-1.1511a.94.94 0 0 1-.0824.1396.81.81 0 0 1-.1502.1609.8.8 0 0 1-.1915.1175.87.87 0 0 1-.2303.0633 1 1 0 0 1-.1259.0084c-.2586 0-.4683-.0999-.6186-.2563l-.7483.7567c.3326.3074.7941.5011 1.3661.5011z"
    />
    <path
      fill="url(#b-IDealWero)"
      d="M27.6299 11.0952c-1.0618 0-1.7445.6682-1.9268 1.492h1.1473c.1373-.2837.4073-.4897.7795-.4897.2967 0 .5271.1282.6774.3219l.7551-.7635c-.3371-.3418-.8223-.5607-1.4317-.5607z"
    />
    <path
      fill="#1d1c1c"
      d="M18.5422 17.1212a.153.153 0 0 1-.1526-.1525v-7.933a.153.153 0 0 1 .1526-.1525.153.153 0 0 1 .1526.1525v7.933a.153.153 0 0 1-.1526.1525"
    />
    <defs>
      <linearGradient
        id="a-IDealWero"
        x1="28.9996"
        x2="27.2818"
        y1="12.8267"
        y2="14.9297"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset=".02" stopColor="#1d1c1c" stopOpacity="0" />
        <stop offset=".68" stopColor="#1d1c1c" />
      </linearGradient>
      <linearGradient
        id="b-IDealWero"
        x1="26.0044"
        x2="27.7649"
        y1="13.273"
        y2="11.5331"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset=".02" stopColor="#1d1c1c" stopOpacity="0" />
        <stop offset=".68" stopColor="#1d1c1c" />
      </linearGradient>
    </defs>
  </SvgIcon>
)
